import useGetter from "./useGetter";

export default function useNflGamesForWeek(season, week) {
  const enabled = !!season;
  const { data: nflGamesData, query: nflGamesQuery } = useGetter(
    `/nfl/${season}/games/${week}`,
    {
      enabled,
    }
  );

  return { nflGamesData, nflGamesQuery };
}
